import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { MaterialModal } from 'components/layout'
import { LogForm } from 'components/forms'
import { form } from 'helpers/decorators'
import validate from './edit-log.validation'

@form({
  form: 'editLog',
  disableHook: true,
  validate
})
class EditLog extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func,
    onEditLog: PropTypes.func,
    reset: PropTypes.func,
    activityId: PropTypes.string,
    colorClass: PropTypes.string,
    modalId: PropTypes.string,
  }

  handleSubmit = data => this.props.onEditLog(data, this.props.activityId, { resetForm: this.props.reset })

  render() {
    const {
      reset,
      modalId,
      colorClass,
      handleSubmit
    } = this.props

    return (
      <MaterialModal.Body
        id={modalId}
        title='Edit Log'
        titleKey='moduleTitle.edit_log'
        colorClass={colorClass}
        onClose={reset}
        onSubmit={handleSubmit(this.handleSubmit)}
      >
        <form onSubmit={handleSubmit(this.handleSubmit)}>
          <MaterialModal.Content>
            <LogForm storeRemoved />
          </MaterialModal.Content>

          <MaterialModal.Footer
            action='Edit Log'
            actionKey='button.edit_log'
            colorClass={colorClass}
          />
        </form>
      </MaterialModal.Body>
    )
  }
}

export default EditLog
